export default __webpack_public_path__ + "static/media/invite_friend_desktop.677b361d.png";